import React, { useState } from "react";
import AdSlot from "./AdSlot";
export default function FreeAreaAdPlaceholder() {
  const [dismissed,setDismissed]=useState(false);
  const [hasContent,setHasContent]=useState(false);
  if(dismissed)return null;
  return <section aria-label="Promotional placement" className={hasContent?"space-y-2":"hidden"}><div className="flex justify-end"><button type="button" onClick={()=>setDismissed(true)} aria-label="Dismiss promotional ad" className="min-h-10 rounded-lg border border-white/10 px-3 text-xs text-zinc-300 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-pink-300">Dismiss</button></div><AdSlot placement="above_footer" onContentChange={setHasContent}/></section>;
}
